import { render } from "./navbar-item.vue?vue&type=template&id=cecadba2"
import script from "./navbar-item.vue?vue&type=script&lang=js"
export * from "./navbar-item.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__